class StickyProductBar extends HTMLElement {
  connectedCallback() {
    this.mainForm = document.querySelector('main form[data-type="add-to-cart-form"]');

    if (!this.mainForm) {
      this.remove();
      return;
    }

    this.hidden = true;
    this.mainProductInfo = this.mainForm.closest('product-info');
    this.mainSectionId = this.mainProductInfo?.dataset.section;
    this.mainButton = this.mainForm.querySelector('button[name="add"]');
    this.button = this.querySelector('button[name="add"]');
    this.labelEl = this.querySelector('[data-sticky-label]');
    this.priceEl = this.querySelector('[data-sticky-price]');

    this.button?.addEventListener('click', (event) => {
      event.preventDefault();
      if (this.button.hasAttribute('disabled')) return;
      this.mainForm.requestSubmit();
    });

    if (this.mainButton && 'IntersectionObserver' in window) {
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            this.hidden = entry.isIntersecting;
          });
        },
        { threshold: 0 }
      );
      this.observer.observe(this.mainButton);
    }

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      this.unsubscribeVariantChange = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        if (!this.mainSectionId || event.data.sectionId !== this.mainSectionId) return;
        this.updateFromVariant(event.data);
      });
    }
  }

  updateFromVariant({ html, variant }) {
    if (this.priceEl && this.mainSectionId) {
      const sourcePrice = html.getElementById(`price-${this.mainSectionId}`);
      if (sourcePrice) this.priceEl.innerHTML = sourcePrice.innerHTML;
    }

    if (this.button) {
      const available = Boolean(variant && variant.available);
      this.button.toggleAttribute('disabled', !available);

      if (this.labelEl && window.variantStrings) {
        this.labelEl.textContent = !variant
          ? window.variantStrings.unavailable
          : !available
            ? window.variantStrings.soldOut
            : window.variantStrings.addToCart;
      }
    }
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    this.unsubscribeVariantChange?.();
  }
}

customElements.define('sticky-product-bar', StickyProductBar);
